import React, { createContext, useState, useEffect } from 'react';

const LOCATIONS_ENDPOINT = process.env.REACT_APP_LOCATIONS_ENDPOINT;
const EVENTS_ENDPOINT = process.env.REACT_APP_EVENTS_ENDPOINT;

export const RemoteDataContext = createContext();

const getPartnerIdentifier = (partner) => Number(partner?.id);

const getPartnersById = (partners) => partners.reduce((acc, partner) => {
    const partnerId = getPartnerIdentifier(partner);
    if (Number.isFinite(partnerId)) {
        acc[partnerId] = partner;
    }
    return acc;
}, {});

export const RemoteDataProvider = ({ children }) => {
    const [locations, setLocations] = useState([]);
    const [locationsById, setLocationsById] = useState([]);
    const [events, setEvents] = useState([]);

    const fetchData = async () => {

        if (window.E3DC_MAP_DATA) {

            const { partners, events } = window.E3DC_MAP_DATA;

            setLocations(partners);
            setLocationsById(getPartnersById(partners));
           
            setEvents(Object.values(events || {}));

        } else {

            const username = process.env.REACT_APP_CONTACT_FORM_AUTH_USERNAME;
            const password = process.env.REACT_APP_CONTACT_FORM_AUTH_PASSWORD;
            const authHeader = 'Basic ' + btoa(`${username}:${password}`);

            try {

                // Fetch both locations and events in parallel
                const [locationsResponse, eventsResponse] = await Promise.all([
                    fetch(LOCATIONS_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': authHeader,
                        }
                    }),
                    fetch(EVENTS_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': authHeader,
                        }
                    }),
                ]);

                if (locationsResponse.ok && eventsResponse.ok) {
                    const locationsData = await locationsResponse.json();
                    const eventsData = await eventsResponse.json();

                    // Set state for locations and events
                    setLocations(locationsData.data || []);
                    setLocationsById(getPartnersById(locationsData.data || []));

                    setEvents(Object.values(eventsData.data || {}));
                }

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <RemoteDataContext.Provider value={{locations, locationsById, events}}>
            {children}
        </RemoteDataContext.Provider>
    );
};